import { Box, Button, Grid, Stack, Typography, styled } from '@mui/material';
import SvgIconStyle from './SvgIconStyle';

export const FormTitle = ({
  icon,
  label,
  needApprove = false,
  onApprove,
  onReject,
  isApproved = null,
  hasCollapse = false,
  collapseState = false,
  onCollapseChange = () => undefined,
}) => 
  // console.log({ label, isApproved, needApprove });
   (
    <Grid item xs={12}>
      <Stack
        display="flex"
        flexDirection="row"
        my={2}
        alignItems="center"
        justifyContent={needApprove || hasCollapse ? 'space-between' : 'flex-start'}
        sx={{ background: '#F4F4F4', width: '100%', padding: '7px 10px', borderRadius: '20px' }}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          sx={{ width: needApprove ? '60%' : '100%', cursor: 'pointer' }}
          onClick={onCollapseChange}
        >
          <IconBox>
            <SvgIconStyle src={`/icons/${icon}.svg`} sx={{ width: 24, height: 24 }} />
          </IconBox>
          <Typography fontSize={16} fontWeight={700} sx={{ color: '#475466' }}>
            {label}
          </Typography>
        </Stack>
        <Stack direction={'row'} alignItems={'center'}>
          {isApproved === true ? (
            <Typography color="#774C9E" mx={2} sx={{ fontSize: '14px', fontWeight: 700 }}>
              تایید شد
            </Typography>
          ) : isApproved === false ? (
            <Typography color="#E50450" mx={2} sx={{ fontSize: '14px', fontWeight: 700 }}>
              رد شد
            </Typography>
          ) : (
            <>
              {needApprove && (
                <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px', zIndex: 999 }}>
                  <Button variant="outlined" color="error" onClick={onReject}>
                    رد کردن
                  </Button>
                  <Button variant="outlined" onClick={onApprove}>
                    تایید کردن
                  </Button>
                </Stack>
              )}
            </>
          )}
          {hasCollapse && (
            <div style={{ margin: '0px 10px', marginTop: '5px' }} aria-hidden onClick={onCollapseChange}>
              <SvgIconStyle src={`/icons/arrow${collapseState ? 'Up' : 'Down'}.svg`} />
            </div>
          )}
        </Stack>
      </Stack>
    </Grid>
  )
;

const IconBox = styled(Box)(() => ({
  backgroundColor: '#F4F4F4',
  width: 32,
  height: 32,
  borderRadius: '10px',
  marginRight: '1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
